import React from 'react';
import './styles.css';
import { gotoUrl } from 'utils/helpers';

const AccountHolderSummary = ({
  accountPrimaryDetails,
  accountSecondaryDetails,
  accountBillingDetails
}) => {
  const onEdit = () =>{
    gotoUrl("/enterprise/automated-account-details?edit=true")
  }
  return (
    <div className="account-summary-card">
      {/* Header */}
      <div className="account-summary-header">
        <h2 className="account-summary-title">Account holder details</h2>
        <button type="button" className="edit-btn" onClick={onEdit}>
          Edit
        </button>
      </div>

      {/* Primary Contact */}
      <div className="summary-section">
        <h3 className="section-subheading">Primary contact</h3>
        <div className="summary-grid">
          <div className="detail-item">
            <span className="detail-label">Full name as shown in NRIC/ID</span>
            <div className="detail-value">{accountPrimaryDetails?.name}</div>
          </div>

          <div className="detail-item">
            <span className="detail-label">Mobile no.</span>
            <div className="detail-value">{accountPrimaryDetails?.mobile_no}</div>
          </div>

          <div className="detail-item full-width">
            <span className="detail-label">Email address</span>
            <div className="detail-value">{accountPrimaryDetails?.email}</div>
          </div>
        </div>
      </div>

      <hr className="summary-divider" />

      {/* Secondary Contact */}
      {accountSecondaryDetails && (
        <>
          <div className="summary-section">
            <h3 className="section-subheading">Secondary contact</h3>
            <div className="summary-grid">
              <div className="detail-item">
                <span className="detail-label">Full name as shown in NRIC/ID</span>
                <div className="detail-value">{accountSecondaryDetails.name}</div>
              </div>

              <div className="detail-item">
                <span className="detail-label">Mobile no.</span>
                <div className="detail-value">{accountSecondaryDetails.mobile_no}</div>
              </div>

              <div className="detail-item full-width">
                <span className="detail-label">Email address</span>
                <div className="detail-value">{accountSecondaryDetails.email}</div>
              </div>
            </div>
          </div>

          <hr className="summary-divider" />
        </>
      )}

      {/* Billing Details */}
      <div className="summary-section">
        <h3 className="section-subheading">Billing details</h3>
        <div className="summary-grid">
          <div className="detail-item full-width">
            <span className="detail-label">Email address</span>
            <div className="detail-value">{accountBillingDetails}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountHolderSummary;